export const LOGIN = 'login';

export const LOGOUT = 'logout';

export const AUTHORIZATIONHEADER = 'authorization'

export const MENU = 'menu'

export const MENUINDEX = 'menuIndex'



// WEBPACK FOOTER //
// ./src/store/types.js